import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";

interface ICreatePasscodeForm {
  passcode: string;
}

const createPasscodeFields: InputField[] = [
  {
    label: "Пароль",
    name: "passcode",
    placeholder: "Офис 1",
    type: "text",
    isRequired: true,
  },
];

export function CreatePasscodeModal({
  disclosure,
  lock,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  lock: number | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: ICreatePasscodeForm) => {
    return new Promise<Boolean>(async (resolve, _reject) => {
      api.locks
        .createPasscode({
          passcode: data.passcode,
          lock_id: lock!,
        })
        .then((_data) => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание пароля"
      modalErrors={modalErrors}
      fields={createPasscodeFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
